import { render, staticRenderFns } from "./Cascader.vue?vue&type=template&id=646a5894&scoped=true"
import script from "./Cascader.vue?vue&type=script&lang=js"
export * from "./Cascader.vue?vue&type=script&lang=js"
import style0 from "./Cascader.vue?vue&type=style&index=0&id=646a5894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646a5894",
  null
  
)

export default component.exports